// @flow
import { connect } from 'react-redux';
import type { StateProps } from './ExternalWebview';
import ExternalWebview from './ExternalWebview';
import type { State } from '../../modules/reducers';
import { customerExternalIdSelector } from '../../modules/Customer/selectors';

const mapStateToProps = (state: State): StateProps => ({
  externalId: customerExternalIdSelector(state),
});

export default connect(mapStateToProps)(ExternalWebview);
